var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoCameraIcon = function SvgVideoCameraIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.75 5.625h12a3 3 0 0 1 3 3v9a.75.75 0 0 1-.75.75H5a3 3 0 0 1-3-3v-9a.75.75 0 0 1 .75-.75M17.75 10.5l5.25-3v9l-5.25-3"
  })));
};
export default SvgVideoCameraIcon;